import heroVideo from './../assets/videos/seafood.mp4'

const SeafoodHero = () => {
  return (
    <section className="relative w-full h-[100svh] overflow-hidden">

      {/* Background Video */}
      <video
        autoPlay
        loop
        muted
        playsInline
        preload="auto"
        disablePictureInPicture
        className="absolute top-0 left-0 w-full h-full object-cover"
        style={{
          transform: 'translate3d(0,0,0)',
          WebkitTransform: 'translate3d(0,0,0)',
        }}
      >
        <source src={heroVideo} type="video/mp4" />
      </video>

      {/* Overlay */}
      <div className="absolute inset-0 bg-black/50 z-10" />

      {/* Content */}
      <div className="relative z-20 flex h-full items-center justify-center px-4 text-center text-white">
        <div className="max-w-[1100px]">

          <h1 className="font-playfair font-bold text-[#D4AF37] text-5xl sm:text-6xl md:text-7xl lg:text-8xl drop-shadow-[0_0_10px_rgba(0,0,0,0.8)]">
            The Seafood Lounge
          </h1>

          <p className="py-6 text-lg md:text-xl drop-shadow-2xl">
            Serving a fresh seafood menu every Friday and Saturday
            from 3 PM till 8:15 PM
          </p>

          <a
            href="https://www.canva.com/design/DAGB9dIGpGk/z7qXGs8G_cxDHItp5SxnHQ/view?utm_content=DAGB9dIGpGk&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks"
            target="_blank"
            rel="noopener noreferrer"
          >
            <button className="bg-[#D4AF37] text-[#1B1F3B] border-2 border-black px-6 py-2 rounded-full font-bold hover:bg-[#1B1F3B] hover:text-[#D4AF37] transition-all duration-300">
              View Menu
            </button>
          </a>

        </div>
      </div>
    </section>
  )
}

export default SeafoodHero